import { getTranslationForIso } from '../shared';

export const generateEditLinkForAdBanner = id => `/adBanners/edit?adBannerID=${id}`;

export const translateAdBanners = (adBanners, iso) => adBanners.map(banner => ({
    ...banner,
    categories: banner.categories && banner.categories.map(category => getTranslationForIso(category, iso))
}));